import React, { useState } from "react"
import { Box, Button, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Layout } from "src/components/layout"
import { SIDE_MENU, SNACKBAR_TYPES } from "src/modules/const"
import { useNavigate, useParams } from "react-router"
import { validateField } from "src/modules/validation"
import { useAuth } from "src/providers/LoginProvider"
import { TagService } from "src/openapi"
import { ShowToast } from "../../states/showToast"
import { ShowProgress } from "../../states/showProgress"
import { useRecoilState } from "recoil"
import InputTextField from "src/components/atom/InputTextField"
import BreadCrumb from "src/components/atom/BreadCrumb"
import AddOutlinedIcon from "@mui/icons-material/AddOutlined"
import * as yup from "yup"
import "./index.scss"
import { Top } from "../top"

export const TagRegister = () => {
  const { t } = useTranslation("translation", { keyPrefix: "tag" })

  const [tag, settag] = useState<string>("")

  const navigate = useNavigate()
  const { companyId } = useParams()

  const { user } = useAuth()

  const [, setShowToast] = useRecoilState(ShowToast)
  const [, setShowProgress] = useRecoilState(ShowProgress)

  const [tagValidationMessage, setTagValidationMessage] = useState<string>("")

  const checkValidation = async () => {
    let valid = true
    valid = valid && tag != ""

    try {
      await validateField(
        yup.object().shape({
          tag: yup.string().required(t("please_input_tag_name")).max(20, t("tag_length_max")),
        }),
        "tag",
        tag
      )
      setTagValidationMessage("")
    } catch (err: any) {
      setTagValidationMessage(err.message)
      valid = valid && false
    }

    return valid
  }

  const handleRegister = async () => {
    if (!(await checkValidation())) {
      return
    }

    if (user == null) {
      return
    }
    setShowProgress(true)

    TagService.createTag(Number(companyId), { tag: tag }, user.token)
      .then(() => {
        setShowProgress(false)
        setShowToast({ show: true, text: t("success_register"), type: SNACKBAR_TYPES.SUCCESS })
        navigate(`/company/${companyId}/tag`)
      })
      .catch(() => {
        setShowProgress(false)
        setShowToast({ show: true, text: t("failed_register"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  if (!user) {
    return <Top />
  }

  return (
    <Layout menu={SIDE_MENU.TAG_LIST}>
      <BreadCrumb
        paths={[
          {
            name: t("list_title"),
            link: `/company/${companyId}/tag`,
          },
          {
            name: t("register_title"),
            link: "",
          },
        ]}
      />
      <Typography className="tag-register-description">{t("register_description")}</Typography>
      <Box className="tag-content-container">
        <Box className="tag-item-container">
          <Box className="tag-item-title">{t("tag_name")}</Box>
          <Box className="tag-item-content-container">
            <InputTextField
              text={tag}
              handleText={settag}
              inputStyle={{ width: "300px", height: "54px" }}
              placeholder={t("tag_name")}
              validationMessage={tagValidationMessage}
            />{" "}
          </Box>
        </Box>
      </Box>
      <Button
        className="tag-register-button"
        sx={{
          width: "200px!important",
          backgroundColor: "#46F3C4",
        }}
        onClick={() => handleRegister()}
      >
        {t("create_tag")}
        <AddOutlinedIcon sx={{ fontSize: "22px" }} />
      </Button>
      <Button
        className="tag-back-button"
        sx={{ width: "200px" }}
        onClick={() => navigate(`/company/${companyId}/tag`)}
      >
        {t("back")}
      </Button>
    </Layout>
  )
}
